import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleFeatures from './features/moduleFeatures.js'
import moduleInternalChatMessages from './internalChatMessages/moduleInternalChatMessages.js'
import moduleInstance from "./instance/moduleInstance";
//import moduleECommerce from './eCommerce/moduleECommerce.js'
// import moduleChatContact from './chatContact/moduleChatContact'
import moduleTicketTransfer from './ticketTransfer/moduleTicketTransfer'
import moduleMessageTemplate from './messageTemplates/moduleMessageTemplate'

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        // todo: moduleTodo,
        // calendar: moduleCalendar,
        chat: moduleChat,
        // email: moduleEmail,
        // chatContact: moduleChatContact,
        auth: moduleAuth,
        ticketTransfer: moduleTicketTransfer,
        messageTemplates: moduleMessageTemplate,
        features: moduleFeatures,
        internalChatMessages: moduleInternalChatMessages,
        instance: moduleInstance
  //      eCommerce: moduleECommerce,
    },
    strict: process.env.NODE_ENV !== 'production'
})
